module.exports = __webpack_public_path__ + "img/hr-puberty-decal-15.290fc784.png";